import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Feature } from 'octali-lib-shop';

@Component({
  selector: 'app-feature-filter-display',
  templateUrl: './feature-filter-display.component.html',
  styleUrls: ['./feature-filter-display.component.scss'],
})
export class FeatureFilterDisplayComponent implements OnInit {

  @Output() select = new EventEmitter<{feature:Feature,values:Array<any>}>();
  @Input() feature:Feature;
  @Input() isAdmin:boolean = false;
  
  @Input() values:any;//:Array<any>;
  private  valuesWithValue:Map<string,string> = new Map<string,string>();

  descending: boolean = true;
  order: number = -1;
  column: string = 'value';
  columnKey: string = 'key';

  constructor() { }

  ngOnInit() {}

  async addValue() {
    /*await this.featureService.addFeatureValue(this.feature).then((res)=> {
      if(res)
        this.featureService.updateFeature(this.feature,false);
    }); */
  }

  selectValue(values) {
    this.values = Array<any>();
    if(values != null && values != "" && values != [] && (values.length == undefined || values.length > 0)){
      if(Array.isArray(values))
        this.values = values;
      else
        this.values.push(values);
    }
    this.select.emit({feature:this.feature,values:this.values});
  }

  setValue(value ,withValue) {
    this.values.set(value,withValue);
    this.select.emit({feature:this.feature,values:this.values});
  }

  compareFn(e1, e2): boolean { 
    if(!e1 || !e2)
      return false;
    if(Array.isArray(e2)){
      var insert:boolean = false;
      for(let v of e2){
          if(e1 == v)
            insert = true;
      }
      return insert;
    }else{
      return (e1 && e2) ? e1 == e2 : false; 
    }
  } 

  sort(){
    this.descending = !this.descending;
    this.order = this.descending ? 1 : -1;
  }

  compareImgFn(e1,e2:Array<any>) :boolean {
    if(!e1 || !e2)
      return false;
      if(Array.isArray(e2)){
        var insert:boolean = false;
        for(let v of e2){
          if(e1[this.feature.nameValue[0]] == v[this.feature.nameValue[0]])
            insert = true;
        }
        return insert;
      }else{
        return (e1 && e2) ? e1[this.feature.nameValue[0]] == e2[this.feature.nameValue[0]] : false;   
      }
  }

}
